import React from "react";
import { FAMILY_TREE_DESIGNS, DESIGN_ORDER } from "./designs";

export function FamilyTreeDesignModal({ open, value, onSelect, onClose }) {
  if (!open) return null;

  return (
    <div className="ft-design-backdrop" onClick={onClose} data-testid="design-modal-backdrop">
      <div
        className="ft-design-modal"
        role="dialog"
        aria-modal="true"
        aria-label="Choose Tree Design"
        onClick={(e) => e.stopPropagation()}
        data-testid="design-modal"
      >
        <div className="ft-design-modal-head">
          <div>
            <span className="eyebrow">Tree Style</span>
            <h2>Choose Tree Design</h2>
            <p>Five beautiful tree variations to represent your family legacy.</p>
          </div>
          <button className="ft-design-close" onClick={onClose} aria-label="Close" data-testid="design-modal-close">
            ×
          </button>
        </div>

        <div className="ft-design-grid" data-testid="design-grid">
          {DESIGN_ORDER.map((id, index) => {
            const design = FAMILY_TREE_DESIGNS[id];
            const selected = value === id;
            return (
              <button
                type="button"
                key={id}
                className={selected ? "ft-design-card selected" : "ft-design-card"}
                aria-pressed={selected}
                onClick={() => {
                  onSelect(id);
                  onClose();
                }}
                data-testid={`design-option-${id}`}
              >
                <span className="ft-design-number">{index + 1}</span>
                <span className="ft-design-thumb" style={{ background: design.background }}>
                  <img src={design.treeImage} alt={design.name} loading="lazy" />
                  {selected && <span className="ft-design-check" aria-hidden="true">✓ Selected</span>}
                </span>
                <span className="ft-design-copy">
                  <strong style={{ color: design.accent }}>{design.name}</strong>
                  <small>{design.tagline}</small>
                  <p>{design.description}</p>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
